import * as _ from 'lodash';
import { Router } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { APP_CONFIG } from "src/app/app.const";
import { onQueueUpdate } from "../basic.queues";
import { ToastService } from "@hss-m/uikit-common";
import { StylistsService } from "../stylists.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UrlUtil } from "src/app/shared/utils/url-utils";
import { DeviceDetectorService } from "ngx-device-detector";
import { AuthService } from "src/app/shared/services/auth.service";
import { QatchComponent } from "src/app/components/qatch.component";
import { Debounce } from "src/app/shared/decorators/debounce.decorator";
import { BUTTONS, ConfirmModalComponent } from "src/app/components/modal/confirm.modal";
import { getErrorMsg } from '../../common/components/dashboard-layout/dashboard.const';
import { onAvailabilityUpdate, onBucketUpdate, onProductPriceUpdate } from "../basic.inventory";
import { AddAllQueuestoQueueComponent } from "./add-all-queues-to-queue/add-all-queues-to-queue";
import { ViewTableComponent } from "src/app/shared/modules/data-view-table/view-table/view-table.component";

@Component({
    template: ''
})
export abstract class BaseUserQueue extends QatchComponent implements OnInit {

    loading: boolean
    filtered = {};
    queuesForSingleUser:boolean = false;
    filterRolesLoaded = false;
    selectedUsers: any[] = [];
    selectedUserName = null;

    constructor(
        protected readonly stylistsService: StylistsService,
        protected router: Router,
        protected override deviceService: DeviceDetectorService,
        protected override authService: AuthService,
        protected toastService: ToastService,
        protected modalService: NgbModal
    ) {
        super(deviceService, authService);
    }

    override ngOnInit() {
        super.ngOnInit();
    }

    onInit() {
        this.getFiltersData(this.stylistsService);
        this.filterRolesLoaded = true;
    }

    abstract getViewTableComponent(): ViewTableComponent;

    openLink(event: any) {
        UrlUtil.openLink(event.affiliate_link);
    }

    navigateTo(event: any) {
        const url = `/console/all-queues/${event.uid}`;
        window.open(url, '_blank');
    }

    @Debounce(APP_CONFIG.DEBOUNCE_INTERVAL)
    onFilterValueChange() {
        this.getViewTableComponent().filters = this.filtered;
        this.getViewTableComponent().setPage({offset: 0});
    }

    isEditable(row: any) {
        return !row.published && !row.sent;
    }

    onTextDateUpdate(value: any, queue: any) {
        this.onQueueUpdated(queue, 'text_date', value, {
            text_date: value
        });
    }

    onAdditionalTextUpdate(value: any, queue: any) {
        this.onQueueUpdated(queue, 'additional_text', value, {
            additional_text: value,
            text_date: queue.text_date
        });
    }

    onMediaUrlUpdate(value: any, queue: any) {
        this.onQueueUpdated(queue, 'media_url', value, {
            media_url: value
        });
    }

    onProductIdUpdate(value: any, queue: any) {
        this.onQueueUpdated(queue, 'product_id', value, {
            product_id: value,
            uid: queue.uid,
        });
    }

    onUIDUpdate(value: any, queue: any) {
        this.onQueueUpdated(queue, 'uid', value, {
            product_id: queue.product_id,
            uid: value,
        });
    }

    onQueueUpdated(queue: any, field: any, nvalue: any, data: any) {
        const callbackFn = field === 'product_id' ? this.onFilterValueChange.bind(this) : null;
        onQueueUpdate(this.stylistsService, this.toastService, {queue, field, nvalue, data}, callbackFn);
    }

    onProductPriceUpdate(value: any, product: any) {
        onProductPriceUpdate(this.stylistsService, this.toastService, this.getViewTableComponent(), value, product);
    }

    onAvailabilityUpdate(value: any, product: any) {
        onAvailabilityUpdate(this.stylistsService, this.toastService, this.getViewTableComponent(), value, product);
    }

    onBucketUpdate(value: any, product: any) {
        onBucketUpdate(this.stylistsService, this.toastService, this.getViewTableComponent(), value, product);
    }

    onDeleteMenuClick() {
        if (!this.getViewTableComponent().selected.length) {
            this.toastService.error({message: `Please select queue(s) to delete`});
        } else {
            const modalRef = this.modalService.open(ConfirmModalComponent, { centered: true });
            modalRef.componentInstance.buttons = [{classes: 'btn-danger', type: BUTTONS.CONFIRM}];
            modalRef.componentInstance.message = 'Are you sure to delete these queue(s)?';
            modalRef.componentInstance.note = 'Please note that Published Or Sent queues will not be deleted.';
            modalRef.result.then((result) => {
                switch (result.type) {
                    case BUTTONS.CONFIRM:
                        const filtered = this.getViewTableComponent().selected
                            .filter(queue => !queue.sent && !queue.published)
                            .map(queue => queue.text_id);
                        if (filtered.length) {
                            this.stylistsService.deleteQueue(filtered).subscribe(resp => {
                                this.toastService.success({message: `Queue(s) has been deleted permanently`});
                                this.getViewTableComponent().setPage({offset: 0});
                                this.getViewTableComponent().selected = [];
                            }, error => {
                                const message = getErrorMsg(error);
                                this.toastService.error({message});
                            });
                        } else {
                            this.toastService.error({message: `Please select queue(s) which are unsent or unpublished`});
                        }
                }
            },(reason) => {});
        }
    }
    
    onAddMenuClick() {
        const modalRef = this.modalService.open(AddAllQueuestoQueueComponent, { centered: true, size: 'lg'});
        modalRef.componentInstance.selectedProducts = this.getViewTableComponent().selected;
        if(this.queuesForSingleUser) {
            modalRef.componentInstance.selectedUsers = this.selectedUsers;
            modalRef.componentInstance.hideUsersInput = true;
        }
        modalRef.result.then((result) => {
            if(result){
                this.getViewTableComponent().setPage({offset: 0});
                this.getViewTableComponent().selected = [];
            }
        },(reason) => {});
    }

    getSentView(event: any) {
        return this.getViewFor(event.sent);
    }

    getPublishedView(event: any) {
        return this.getViewFor(event.published);
    }

    private getViewFor(value: any) {
        return value ? '<div class="text-success"><i class="bi bi-check2"></i></div>' : '';
    }
}